import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Paper,
  Grid,
  Avatar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import {
  CheckCircleOutline,
  ErrorOutline,
  ExpandMore as ExpandMoreIcon,
  InfoOutlined,
} from '@mui/icons-material';

interface UploadResultProps {
  data: {
    totalRecord: number;
    successRecord: number;
    failRecord: number;
    errorMessages: string[];
  };
}

export const UploadResult: React.FC<UploadResultProps> = ({ data }) => {
  return (
    <Paper
      variant="outlined"
      sx={{ p: 3, mt: 3, borderRadius: '16px' }}
    >
      <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
        Yükleme Sonucu
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Avatar sx={{ bgcolor: 'info.light', color: 'info.dark', mr: 2 }}>
              <InfoOutlined />
            </Avatar>
            <Box>
              <Typography variant="h6">{data.totalRecord}</Typography>
              <Typography variant="body2" color="text.secondary">
                Toplam Kayıt
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Avatar sx={{ bgcolor: 'success.light', color: 'success.dark', mr: 2 }}>
              <CheckCircleOutline />
            </Avatar>
            <Box>
              <Typography variant="h6">{data.successRecord}</Typography>
              <Typography variant="body2" color="text.secondary">
                Başarılı
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Avatar sx={{ bgcolor: 'error.light', color: 'error.dark', mr: 2 }}>
              <ErrorOutline />
            </Avatar>
            <Box>
              <Typography variant="h6">{data.failRecord}</Typography>
              <Typography variant="body2" color="text.secondary">
                Hatalı
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>

      {data.errorMessages && data.errorMessages.length > 0 && (
        <Accordion
          elevation={0}
          sx={{
            mt: 3,
            bgcolor: 'transparent',
            borderTop: '1px solid',
            borderColor: 'divider',
            '&:before': {
              display: 'none',
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Hata Mesajları ({data.errorMessages.length})</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List dense sx={{ maxHeight: 300, overflow: 'auto' }}>
              {data.errorMessages.map((msg, index) => (
                <ListItem key={index}>
                  <ListItemText primary={msg} />
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      )}
    </Paper>
  );
};
